module.exports = __webpack_public_path__ + "media/images/favicons/safari-pinned-tab-2772a302a5e491c7ef27aa0c9ee2c481.svg";